// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native";
import colors from ".././config/colors";
import fonts from "../config/fonts";
const HeaderStyle = StyleSheet.create({
  container: {
    backgroundColor: colors.green,
    width: "100%",
    height: 170,
    flexDirection: "column",
    justifyContent: "space-between",
    paddingHorizontal: 15,
    paddingTop: 50,
    paddingBottom: 50,
  },
  firstLine: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
    fontFamily: fonts.regular,
    fontWeight: "normal",
  },
  secondLine: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: fonts.regular,
    paddingVertical: 5,
  },
  secondLineAlignment: {
    alignItems: "center",
  },
  logo: {
    width: 105,
    height: 50,
    marginRight: 10,
  },
  tabIcon: {
    marginRight: 5,
  },
  title: {
    color: "white",
    fontSize: 20,
    fontFamily: fonts.regular,
    fontWeight: "normal",
  },
  subtitle: {
    color: "white",
    fontSize: 10,
    fontFamily: fonts.regular,
    fontWeight: "normal",
  },
  languageSwitchContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 20,
  },
  languageSwitchButton: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
    borderRadius: 20,
    marginLeft: 5,
    backgroundColor: "rgba(255, 255, 255, 0.2)", // Slightly translucent background
    borderWidth: 1,
    borderColor: "transparent", // Default border color
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 2, // For Android shadow
    transition: "all 0.3s ease", // Smooth transition
  },
  languageSwitchButtonActive: {
    backgroundColor: "#ffffff", // Solid background for active button
    borderColor: colors.greenWater, // Border color for active button
    borderWidth: 2,
    shadowOpacity: 0.5,
    shadowRadius: 6,
    elevation: 4,
  },
  languageFlag: {
    width: 30,
    height: 20,
    marginRight: 8,
  },
  languageText: {
    color: "white",
    fontSize: 16,
  },
  
});

export default HeaderStyle;
